export const DOWNLOAD_MOBILE = 'http://appstore.equell.com/';
export const DOWNLOAD_CHROME = 'https://equell.com/chrome.html';
